<template>
  <fusioncharts
      :type="type"
      :width="width"
      :height="height"
      :dataformat="dataFormat"
      :dataSource="dataSource"
  />
</template>

<script>
  const dataSource = {
    chart: {
      caption: "График 8 (смешанный)",
      xAxisname: 'Номер месяца',
      yAxisname: 'Сумма по полю',
      "toolTipColor": "#ffffff",
      "toolTipBorderThickness": "0",
      "toolTipBgColor": "#000000",
      "toolTipBgAlpha": "80",
      "toolTipBorderRadius": "2",
      "toolTipPadding": "5",
      theme: "fusion"
    },
    categories: [{
      category: [
        { label: '3' },
        { label: '4' },
        { label: '7' },
        { label: '8' },
        { label: '9' },
        { label: '10' },
        { label: '11' },
        { label: '12' }
      ]
    }],
    dataset: [{
      seriesname: 'Сумма по полю ЦЕНА_ДЛЯ_ГП_разгр_За_Тонну',
      renderAs: 'line',
      data: [
        { value: 378220.00 },
        { value: 177565.00 },
        { value: 1617305.00 },
        { value: 1298080.00 },
        { value: 1199610.00 },
        { value: 3311423.00 },
        { value: 3765732.00 },
        { value: 1562425.00 }
      ]
    }, {
      seriesname: 'Сумма по полю Масса разгруженная',
      data: [
        { value: 13278.70 },
        { value: 4592.25 },
        { value: 58628.84 },
        { value: 40382.67 },
        { value: 37233.39 },
        { value: 80850.45 },
        { value: 87097.42 },
        { value: 54561.42 }
      ]
    }, {
      seriesname: 'Сумма по полю Дистанция, км',
      data: [
        { value: 121048.18 },
        { value: 60999.34 },
        { value: 335371.28 },
        { value: 368870.82 },
        { value: 328795.98 },
        { value: 814558.17 },
        { value: 957675.89 },
        { value: 370012.72 }
      ]
    }, {
      seriesname: 'Сумма по полю Тонна/км',
      data: [
        { value: 3.12 },
        { value: 2.91 },
        { value: 4.82 },
        { value: 3.52 },
        { value: 3.65 },
        { value: 4.07 },
        { value: 3.93 },
        { value: 4.22 }
      ]
    }]
  };

  export default {
    data() {
      return {
        type: "mscombi2d",
        width: 800,
        height: 500,
        dataFormat: "json",
        dataSource
      };
    }
  }
</script>

<style scoped>

</style>